// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"242":"66415994","451":"5b0750d4","508":"b1dc33a4","668":"221036b9","977":"9baef086","981":"7e0d3db5"}[chunkId] + ".css";
};